<div class="" fxLayout="column" fxLayoutAlign="start stretch">
  <h2 mat-dialog-title>Información importante sobre el contenido del correo</h2>
  <mat-dialog-content class="mat-typography">
    <p>
      Para que el correo sea considerado correcto para envíar a validación por parte de un jefe de proyecto, el mensaje debe contener al menos una vez, las siguientes etiquetas
    </p>
    <mat-list>
      <mat-list-item *ngFor="let etiqueta of etiquetas; last as last">
        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
        <h4 mat-line><b>{{etiqueta.tag}}</b></h4>
        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
    <p>La razón de esto, es debido a que al llegar el momento del envío de correos, la plataforma realiza los siguientes reemplazos en el mensaje, de manera automática:</p>
    <mat-list>
      <mat-list-item *ngFor="let etiqueta of etiquetas; last as last">
        <mat-icon mat-list-icon>keyboard_arrow_right</mat-icon>
        <h4 mat-line><b>{{etiqueta.tag}}</b> = <em>{{etiqueta.info}}</em></h4>
        <mat-divider [inset]="true" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
    <p>
      Las etiquetas pueden colocarse en cualquier lugar del cuerpo del correo. Una vez que las etiquetas estén presentes en el contenido, este podrá ser guardado.<br><br>
      Posteriormente, un jefe de proyecto deberá revisarlo y validarlo. Podrá ver el estado de validación del nuevo correo en esta pantalla. Durante el proceso de validación no podrá realizar una nueva edición del correo.
    </p>
  </mat-dialog-content>


  <div fxLayout="column" fxLayoutAlign="start center">
    <button mat-raised-button color="accent" class="mt-20" (click)="salir()">
      Cerrar
      <mat-icon class="ml-20">clear</mat-icon>
    </button>
  </div>
</div>
